import { gql } from 'graphql-tag';

export const submitFormOpName = 'formSubmit';

export const formSubmit = gql`
  mutation ${submitFormOpName}($input: FormSubmitInput!) {
    formSubmit(input: $input)
  }
`;
